export default __webpack_public_path__ + "static/media/check_icon.8d9ac042.svg";